"use client";
import useMeasure from "react-use-measure";

import {
  Img1,
  Img3,
  Img7,
  Img9,
  Img41,
  Img42,
  Img40,
  Img37,
  Img34,
  Img38,
  Img33,
} from "@/public/assets";

function useHome() {
  const duration = 90;
  const [sliderRefL1, { width: widthL1, height: heightL1 }] = useMeasure();
  const [sliderRefL2, { width: widthL2, height: heightL2 }] = useMeasure();
  const [sliderRefL3, { width: widthL3, height: heightL3 }] = useMeasure();
  const [sliderRefL4, { width: widthL4, height: heightL4 }] = useMeasure();
  const [sliderRefL5, { width: widthL5, height: heightL5 }] = useMeasure();

  const lSliderData = [
    { ref: sliderRefL1, width: widthL1, height: heightL1 },
    { ref: sliderRefL2, width: widthL2, height: heightL2 },
    { ref: sliderRefL3, width: widthL3, height: heightL3 },
    { ref: sliderRefL4, width: widthL4, height: heightL4 },
    { ref: sliderRefL5, width: widthL5, height: heightL5 },
  ];

  const teamMembers = [
    {
      id: 1,
      avatar: Img1.src,
      first_name: "Ade",
      last_name: "Damilare",
      position: "Brand Designer",
    },
    {
      id: 3,
      avatar: Img3.src,
      first_name: "Madison",
      last_name: "Emmanuel",
      position: "Marketing Expert",
    },
    {
      id: 7,
      avatar: Img7.src,
      first_name: "Coach",
      last_name: "Wisdom",
      position: "Fitness Trainer",
    },
    {
      id: 9,
      avatar: Img9.src,
      first_name: "Timmy",
      last_name: "Malagbo",
      position: "Suit Tailor",
    },
    {
      id: 13,
      avatar: Img41.src,
      first_name: "Helen",
      last_name: "Agbor",
      position: "Dance Instructor",
    },
    {
      id: 14,
      avatar: Img42.src,
      first_name: "Helen",
      last_name: "Agbor",
      position: "Dance Instructor",
    },
    {
      id: 15,
      avatar: Img40.src,
      first_name: "Helen",
      last_name: "Agbor",
      position: "Dance Instructor",
    },
    {
      id: 16,
      avatar: Img37.src,
      first_name: "Helen",
      last_name: "Agbor",
      position: "Dance Instructor",
    },
    {
      id: 17,
      avatar: Img34.src,
      first_name: "Helen",
      last_name: "Agbor",
      position: "Dance Instructor",
    },
    {
      id: 18,
      avatar: Img38.src,
      first_name: "Helen",
      last_name: "Agbor",
      position: "Dance Instructor",
    },
    {
      id: 19,
      avatar: Img33.src,
      first_name: "Helen",
      last_name: "Agbor",
      position: "Dance Instructor",
    },
  ];

  return {
    teamMembers,
    duration,
    lSliderData,
  };
}

export default useHome;
